import { useBusinessModalContext as e } from "../../../BusinessModalContext.js";
const s = "city", r = () => {
  const {
    preFilters: t
  } = e();
  return {
    [s]: t?.searchCity
  };
};
export {
  r as useGetCity
};
